import { FC } from "react";
import { Tooltip } from "antd";
import styles from '../Styles/ChangeableGrid.module.scss'
import { IAlertHolder } from "../../../alert/alertHelpers";

interface IAlertCellProps {
    displayItem: IAlertHolder;
}

export const AlertCell: FC<IAlertCellProps> = ({
    displayItem,
}) => {

    const messages = [
        ...(displayItem.alerts ?? [])
    ].map(alert => alert.message);

    return messages.length ? (
        <Tooltip
            title={
                <div>
                    {messages.map((text, i) => (
                        <div key={i}>• {text}</div>
                    ))}
                </div>
            }
            placement="top"
            autoAdjustOverflow={false}
            getPopupContainer={() => document.body}
        >
            <div className={styles.alertCircle}>!</div>
        </Tooltip>
    ) : null;
};